import React, { useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTelegram,
  FaYoutube,
} from "react-icons/fa";
import { WiTime10 } from "react-icons/wi";
import Moment from "react-moment";
import Typed from "react-typed";
// import GoogleMapReact from "google-map-react";

const contacts = [
  { id: 1, text: "+998993807738" },
  { id: 2, text: "abdulazizprogramer@gmail.com" },
  { id: 3, text: "https://github.com/AbdulazizCreator" },
];

// const AnyReactComponent = ({ text }) => <div>{text}</div>;

function About(props) {
  const [date, setDate] = useState(new Date());
  const time = () => {
    setInterval(() => {
      setDate(new Date());
    }, 1000);
  };
  // const defaultProps = {
  //   center: {
  //     lat: 41.3171,
  //     lng: 69.2494,
  //   },
  //   zoom: 11,
  // };
  return (
    <div className="about">
      <div className="aboutMe" data-aos="fade-up">
        <h1 data-aos="fade-up">I am Toshpo'latov Abdulaziz</h1>
        <p data-aos="fade-up">
          My nickname is AbdulazizProgrammer, I am frontEnd developer now, but I
          will be fullStack Web developer in this year
        </p>
        <h2>
          I know{" "}
          <Typed
            strings={["html", "css", "sccs", "react", "bootstrap"]}
            typeSpeed={40}
            loop
          />
        </h2>
        <div className="aboutDate" data-aos="fade-up">
          <h2>
            My age: {"  "}
            <Moment fromNow ago>
              2000-07-19T12:59-0500
            </Moment>
            <span> old</span>
          </h2>
          <div className="currentTime">
            <WiTime10 />
            <h2>
              {date.toLocaleTimeString()}
              {time()}
            </h2>
          </div>
        </div>
        <div className="mapContacts">
          <div className="map">
            <iframe
              title="This is a unique title"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5992.17933328355!2d69.24766302467654!3d41.328663517078226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8b6fd7ce29f1%3A0x6e45b1ea5740d6a6!2sJangokh%2C%20Tashkent%2C%20Uzbekistan!5e0!3m2!1sen!2s!4v1610571920771!5m2!1sen!2s"
              frameborder="0"
              style={{ border: 0, width: '100%', height: '100%' }}
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>
          <div className="contacts" data-aos="fade-up">
            <p>
              <span>My phone:</span> {contacts[0].text}
            </p>
            <p>
              <span>My email:</span> {contacts[1].text}
            </p>
            <p>
              <span>
                My github: {"  "}
                <a href="https://github.com/AbdulazizCreator">
                  {contacts[2].text}
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="aboutMassMedia" data-aos="fade">
        <img data-aos="fade-up" src="images/man-02.png" alt="" />
        <h2>My Mass Media</h2>
        <ul className="header__ul">
          <li>
            <a href="https://www.facebook.com/abdulaziz.programmer.56">
              <FaFacebookF className="headerIcon" />
              <img src="images/men.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="https://web.telegram.org/#/im?p=@AbdulazizLeader">
              <FaTelegram className="headerIcon" />
              <img src="images/men.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/abdulazizleader/">
              <img src="images/men.jpg" alt="" />

              <FaInstagram className="headerIcon" />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCOlJa25ucIiZiMc1xyNv-2Q">
              <img src="images/men.jpg" alt="" />
              <FaYoutube className="headerIcon" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default About;

// <h2>Toshpo'latov Abdulaziz</h2>
// <p>Yoshim 20 da</p>
// <p>Ijtimoiy tarmoqlarim</p>
// <p>Oila azolarim</p>
